import { useState, useEffect } from "react";
import apiClient from "../../utils/apiClient";
import YourKitchenForm from "../../components/preferences/YourKitchen";
import { useNavigate } from "react-router-dom";

export default function OnboardYourKitchen() {
  const [prefs, setPrefs] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient.get(`/users/preferences`).then(res => setPrefs(res.data));
  }, []);

  const handleSave = async (updated) => {
    const res = await apiClient.put(`/users/preferences`, updated);
    setPrefs(res.data);
    navigate("/onboard/your-meals");
  };

  return (
    <div className="max-w-md mx-auto mt-8 space-y-6 px-4">
      <h1 className="text-2xl font-bold">About your kitchen</h1>
      <p>How well stocked do you keep your kitchen? Should we assume only the very basics, or are in a wonderful fully-stocked culinary wonderland.</p>
      {prefs && <YourKitchenForm prefs={prefs} onSubmit={handleSave} btnText={"Next"}/>}
    </div>
  );
}
